const AppConfig = {
  TIMEOUT_TO_ALERT_NO_INTERNET: 10000,
  MAX_UNSAVED_LIMIT_TO_STORE: 100,
  REFERRAL_BASE: 'https://www.kontentino.com/referral-program/',
  ATTACHMENTS_MEDIA_UPLOAD_PARALLEL_CONCURRENCY: 5,
  SOCIAL_LOGIN_BROADCAST_CHANNEL_NAME: 'social-login',
  BOOK_DEMO_CALENDLY:
    'https://calendly.com/clicktobookademo/demo-with-kontentino-onboarding?month',
};

export default AppConfig;
